module.exports = __webpack_public_path__ + "static/media/ncj_bangle_0010.529fdc13.jpg";